import { graphql } from 'react-relay';

export const createDrawingSetVersionMutation = graphql`
    mutation createDrawingSetVersionMutation($input: DrawingSetVersionCreateInput!, $connections: [ID!]!) {
        createDrawingSetVersion(input: $input) {
            edge @appendEdge(connections: $connections) {
                cursor
                node {
                    ...drawingSetFragment
                }
            }
            uploadFields
            uploadUrl
        }
    }
`;
